var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01Jspevjfy7Tm6Sjzx3F9G5Rxp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.334 20.502C19.0954 20.502 21.334 18.2634 21.334 15.502C21.334 12.7405 19.0954 10.502 16.334 10.502C13.5726 10.502 11.334 12.7405 11.334 15.502C11.334 18.2634 13.5726 20.502 16.334 20.502Z",
    stroke: "#201F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30859 25.4237C9.06186 23.9427 10.2102 22.6991 11.6266 21.8304C13.043 20.9617 14.6722 20.502 16.3337 20.502C17.9952 20.5019 19.6244 20.9617 21.0408 21.8304C22.4572 22.699 23.6055 23.9427 24.3588 25.4237",
    stroke: "#201F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.334 7.50195H28.334",
    stroke: "#201F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.334 4.50195V10.502",
    stroke: "#201F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1847 14.6092C28.5819 17.1099 28.1772 19.6721 27.0284 21.9286C25.8796 24.1851 24.0459 26.0198 21.7901 27.1699C19.5343 28.3199 16.9722 28.7261 14.4713 28.3303C11.9704 27.9345 9.65902 26.757 7.86859 24.9665C6.07816 23.1761 4.90063 20.8647 4.50481 18.3638C4.109 15.8629 4.51523 13.3009 5.66526 11.045C6.8153 8.78923 8.65008 6.95549 10.9065 5.80672C13.163 4.65796 15.7253 4.25318 18.226 4.6504",
    stroke: "#201F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Jspevjfy7Tm6Sjzx3F9G5Rxp);
export default __webpack_public_path__ + "static/media/01JSPEVJFY7TM6SJZX3F9G5RXP.07297bd56f1e7f85bca971c659c708dd.svg";
export { ForwardRef as ReactComponent };